import { ReducerRegistry } from '../../core-bundle';

import { wallpaperReducer } from '../store/reducer';

export function initWallpaperBundle() {
  // Register wallpaper reducer into the main registry
  ReducerRegistry.register('wallpaper', wallpaperReducer);
}

initWallpaperBundle();
